<template>
  <div class="min-h-screen relative">
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div>
      <div
        v-if="loading"
        class="flex items-center justify-center"
        style="height: calc(100vh - 350px) !important"
      >
        <img src="@/assets/newd/loading.gif" alt="" />
      </div>
      <div v-else class="min-h-screen w-full container mx-auto">
        <section
          id="UserProfile"
          v-if="profileInfo"
          class="w-full py-3 mt-10 flex flex-col md:flex-row flex-wrap gap-20 items-start justify-center"
        >
          <!-- Profile Card -->
          <div
            class="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-6 text-center w-full lg:w-[320px] mt-6 border border-gray-100/50 hover:shadow-2xl transition-all duration-300"
          >
            <div class="flex flex-col items-center relative">
              <div class="relative group">
                <div v-if="profileInfo.data.profile == 'None'">
                  <div
                    class="w-28 h-28 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-4xl text-white font-bold shadow-lg"
                  >
                    {{ profileInfo.data.user.slice(0, 1).toUpperCase() }}
                  </div>
                  <!-- <img
                src="@/assets/new/image.png"
                alt="Profile Picture"
                class="w-24 h-24 rounded-full"
              /> -->
                </div>
                <div v-else class="relative">
                  <img
                    :src="profileInfo.data.profile"
                    alt="Profile Picture"
                    class="w-28 h-28 rounded-full object-cover border-4 border-white shadow-lg"
                  />
                  <div
                    class="absolute inset-0 rounded-full bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                  >
                    <span class="text-white text-sm font-medium">Change</span>
                  </div>
                </div>

                <button
                  @click="changeProfile = true"
                  class="absolute -bottom-2 -right-2 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-110"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </button>
              </div>

              <form
                v-if="changeProfile"
                @submit.prevent="imageHandles"
                class="py-4 flex flex-col items-center justify-center gap-4 w-full bg-gray-50 rounded-xl p-4 mt-4"
              >
                <input
                  type="file"
                  name=""
                  id="image_uploads"
                  required
                  class="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                <div class="flex items-center gap-3">
                  <button
                    type="submit"
                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-md hover:shadow-lg transition-all"
                  >
                    Change Photo
                  </button>
                  <button
                    @click="changeProfile = false"
                    class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-md hover:shadow-lg transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>

            <div class="mt-6">
              <h2 class="text-2xl font-bold text-gray-900 capitalize">
                {{ profileInfo.data.user }}
              </h2>
            </div>
            <p class="text-xs text-gray-500 py-3">
              <span class="font-bold">PRN </span>:
              {{ profileInfo.data.prn_number || "NA" }}
            </p>
            <div class="mt-8 pt-6 border-t border-gray-100">
              <div class="flex justify-center gap-4">
                <a
                  :href="profileInfo.data.linkedin"
                  target="_blank"
                  title="LinkedIn"
                  class="text-gray-400 hover:text-blue-600 transition-colors duration-200"
                >
                  <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <!-- Personal Details Card -->
          <div
            class="flex flex-col gap-5 justify-center px-6 md:py-10 w-full xl:w-[720px]"
          >
            <div class="flex flex-wrap gap-2 border-b border-gray-200 pb-4">
              <button
                v-for="tab in tabs"
                :key="tab"
                @click="active_tab = tab"
                :class="[
                  'px-6 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 capitalize',
                  active_tab == tab
                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-200'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
                ]"
              >
                {{ tab }}
              </button>
            </div>
            <div
              v-if="active_tab == 'profile details'"
              class="w-full flex flex-col gap-6"
            >
              <div class="flex justify-between items-center">
                <h3 class="text-xl font-bold text-gray-900">
                  Personal Details
                </h3>
              </div>

              <div class="bg-gray-50 rounded-xl p-6">
                <dl class="divide-y divide-gray-200">
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Full Name
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.user }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Role
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ this.userInfo.user.permission }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Email
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.Email }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Mobile
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.mobile || "Not provided" }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Batch
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.batch || "None" }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Program
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.program || "None" }}
                    </dd>
                  </div>
                  <!-- <div class="py-3 flex flex-col sm:flex-row">
                  <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                    Department
                  </dt>
                  <dd class="text-sm text-gray-900 sm:w-2/3">
                    {{ profileInfo.data.department || "None" }}
                  </dd>
                </div> -->
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Semester
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.semester || "None" }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Address
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      {{ profileInfo.data.address || "Not provided" }}
                    </dd>
                  </div>
                  <div class="py-3 flex flex-col sm:flex-row">
                    <dt class="text-sm font-medium text-gray-500 sm:w-1/3">
                      Description
                    </dt>
                    <dd class="text-sm text-gray-900 sm:w-2/3">
                      <p class="leading-relaxed">
                        {{
                          profileInfo.data.description?.slice(0, 180) || "None"
                        }}
                        <button
                          v-if="profileInfo.data.description?.length > 180"
                          class="text-blue-600 hover:text-blue-700 font-medium ml-1"
                        >
                          ...Read More
                        </button>
                      </p>
                    </dd>
                  </div>
                </dl>
              </div>
              <div class="mt-4 flex flex-wrap justify-center gap-3">
                <div class="flex flex-wrap gap-4">
                  <button
                    @click="ProfileEdit"
                    class="px-6 py-2.5 bg-blues hover:bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                    Edit
                  </button>

                  <button
                    @click="ChangePasswordPopup"
                    class="px-6 py-2.5 bg-blues hover:bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 7a4 4 0 11-8 0 4 4 0 018 0zM3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"
                      />
                    </svg>
                    Change Password
                  </button>
                </div>

                <!-- <router-link
                  class="flex items-center gap-2 px-4 py-2 text-white bg-[#0085DB] rounded-lg"
                >
                  <img
                    src="@/assets/newd/changee.png"
                    alt="Change Icon"
                    class="w-5 h-5"
                  />
                  <span class="text-sm font-medium">Change Password</span>
                </router-link> -->
              </div>
            </div>
            <div v-if="active_tab == 'accessible course'" class="">
              <div class="flex justify-between items-center">
                <h3 class="text-xl font-bold text-gray-900">
                  Courses
                  <span class="ml-2 text-sm font-normal text-gray-500">
                    ({{ course_count || 0 }})
                  </span>
                </h3>
                <div class="flex justify-end">
                  <div class="relative w-full md:max-w-80">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      v-model="searching"
                      @input="getCourses(1)"
                      placeholder="Search..."
                      class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <button
                      v-if="searching"
                      @click="clearSearch"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="w-full flex flex-col gap-5 py-5"
                v-if="course_list.length > 0"
              >
                <div
                  class="w-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
                >
                  <table class="min-w-full">
                    <thead>
                      <tr
                        class="text-left bg-gray-100 text-blues whitespace-nowrap text-sm capitalize"
                      >
                        <th class="px-4 py-3 border-b border-r">S.No</th>
                        <th class="px-4 py-3 border-b border-r">
                          Course Title
                        </th>
                        <th class="px-4 py-3 border-b border-r hidden">
                          description
                        </th>
                        <th class="px-4 py-3 border-b border-r">Course Code</th>
                        <th class="px-4 py-3 border-b border-r hidden">
                          Section
                        </th>
                        <th class="px-4 py-3 border-b border-r">created at</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(course, index) in course_list"
                        :key="course.id"
                        class="border-b pb-3 w-full cursor-pointer hover:bg-gray-100 text-sm"
                      >
                        <td class="px-4 py-3 border-b border-r text-gray-500">
                          {{ (current_page - 1) * pageSize + (index + 1) }}
                        </td>
                        <td class="px-4 py-3 border-b border-r text-gray-800">
                          {{ course.title }}
                        </td>
                        <td class="px-4 py-3 border-b border-r hidden">
                          {{ course.short_description }}
                        </td>
                        <td
                          class="px-4 py-3 border-b border-r text-gray-500 text-xs"
                        >
                          {{ course.course_code }}
                        </td>
                        <td
                          class="px-4 py-3 border-b border-r text-gray-500 hidden"
                        >
                          {{ course.class_section }}
                        </td>
                        <td
                          class="px-4 py-3 border-b border-r text-gray-500 text-xs"
                        >
                          {{ formatDate(course.updated_at) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getCourses"
                /> -->
                <div
                  class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
                >
                  <!-- PAGE SIZE -->
                  <div
                    class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                  >
                    <span class="flex md:hidden">Rows per page:</span>
                    <select
                      v-model="pageSize"
                      @change="onPageSizeChange"
                      class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                  </div>

                  <!-- PAGINATION -->
                  <div v-if="totalPages > 1" class="flex justify-center">
                    <Pagination
                      :totalPages="totalPages"
                      ref="paginationRef"
                      @page-changed="this.getCourses"
                    />
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="flex flex-col items-center justify-center gap-4 py-16 px-4"
                >
                  <div class="bg-gray-50 rounded-full p-6">
                    <svg
                      class="w-16 h-16 text-gray-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  <div class="text-center">
                    <h3 class="text-gray-600 text-lg font-semibold mb-1">
                      No courses available
                    </h3>
                    <p class="text-gray-400 text-sm">
                      Get started by creating a new course
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- PopUp -->
      <div
        v-if="popUp && updateDetails != null"
        class="fixed inset-0 z-50 overflow-y-auto"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-900/75 transition-opacity"
            aria-hidden="true"
            @click="popUp = false"
          ></div>

          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          >
            <div class="bg-white px-6 py-5 border-b border-gray-100">
              <div class="flex justify-between items-center">
                <h3 class="text-xl font-bold text-blue-600">Edit Details</h3>
                <button
                  @click="popUp = false"
                  class="text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <form @submit.prevent="SubmitProfile" class="px-6 py-5 space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Mobile
                </label>
                <input
                  type="tel"
                  v-model="updateDetails.mobile"
                  placeholder="Mobile number"
                  class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm bg-gray-50 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                  readonly
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Address
                </label>
                <input
                  type="text"
                  v-model="updateDetails.address"
                  class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                  placeholder="Enter your address"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Description
                </label>
                <textarea
                  v-model="updateDetails.description"
                  rows="4"
                  class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none resize-none"
                  placeholder="Write a short description about yourself"
                ></textarea>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  LinkedIn Profile
                </label>
                <input
                  type="url"
                  v-model="updateDetails.linkedin"
                  class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                  placeholder="https://linkedin.com/in/username"
                />
              </div>

              <div class="flex justify-center pt-5">
                <button
                  type="submit"
                  class="w-full max-w-[200px] px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-blue-600 shadow-md hover:shadow-lg transition-all"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        v-if="changePassword"
        class="fixed inset-0 z-50 overflow-y-auto"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-900/75 transition-opacity"
            aria-hidden="true"
            @click="changePassword = false"
          ></div>

          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full"
          >
            <div class="bg-white px-6 py-5 border-b border-gray-100">
              <div class="flex justify-between items-center">
                <h3 class="text-xl font-bold text-blue-600">Change Password</h3>
                <button
                  @click="changePassword = false"
                  class="text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <form @submit.prevent="changepassword" class="px-6 py-5 space-y-4">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Old Password <span class="text-red-400">*</span></label
                >

                <div class="flex items-center relative">
                  <input
                    type="password"
                    id="oldpassword"
                    class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                    placeholder="Enter old password"
                    required
                  />

                  <img
                    v-if="passwordType == 'oldpassword'"
                    src="@/assets/eyeslash.svg"
                    @click="hideShow('oldpassword')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                  <img
                    v-else
                    src="@/assets/eye.svg"
                    @click="hideShow('oldpassword')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                </div>
              </div>
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >New Password <span class="text-red-400">*</span></label
                >

                <div class="flex items-center relative">
                  <input
                    type="password"
                    id="oldtoNew"
                    class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                    placeholder="Enter new password"
                    required
                  />

                  <img
                    v-if="passwordType == 'oldtoNew'"
                    src="@/assets/eyeslash.svg"
                    @click="hideShow('oldtoNew')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                  <img
                    v-else
                    src="@/assets/eye.svg"
                    @click="hideShow('oldtoNew')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >New Confirm Password
                  <span class="text-red-400">*</span></label
                >

                <div class="flex items-center relative">
                  <input
                    type="password"
                    id="changeconfirm"
                    class="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm pr-10 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none"
                    placeholder="Confirm new password"
                    required
                  />

                  <img
                    v-if="passwordType == 'changeconfirm'"
                    src="@/assets/eyeslash.svg"
                    @click="hideShow('changeconfirm')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                  <img
                    v-else
                    src="@/assets/eye.svg"
                    @click="hideShow('changeconfirm')"
                    alt=""
                    class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                  />
                </div>
              </div>

              <div class="flex justify-center pt-5">
                <button
                  type="submit"
                  class="w-full px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-blue-600 shadow-md hover:shadow-lg transition-all"
                >
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        id="image_uploads"
        class="bg-white rounded-lg shadow-sm w-[350px] outline-none"
      >
        <!-- Your content here -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";
import { mapGetters, mapMutations } from "vuex";
import Header from "@/components/Student/Header.vue";
import Pagination from "@/components/Pagination.vue";
import { faLaugh } from "@fortawesome/free-regular-svg-icons";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      loading: true,
      messages: {
        text: "",
        type: "null",
      },
      selectedcontent: "Courses",
      searching: "",
      courseDetails: null,
      boughtcourse: null,
      changePassword: false,
      passwordType: "password",
      tabs: ["profile details", "accessible course"],
      active_tab: "profile details",
      course_list: "",
      totalPages: 1,
      current_page: 1,
      pageSize: 10,
      course_count: null,

      selectedInstructors: [],
      changeProfile: false,
    };
  },

  components: {
    Header,
    FlashMessage,
    Pagination,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    await this.openProcess();
    await this.getCourses(1);
    this.loading = false;
  },

  methods: {
    clearSearch() {
      this.searching = "";
      this.getCourses(1);
    },

    ...mapMutations(["updateImage"]),

    hideShow(id) {
      const passwordField = document.querySelector(`#${id}`);
      passwordField.getAttribute("type") === "password"
        ? passwordField.setAttribute("type", "text")
        : passwordField.setAttribute("type", "password");
      if (this.passwordType == id) {
        this.passwordType = "password";
      } else {
        this.passwordType = id;
      }
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getCourses(1);
    },
    ChangePasswordPopup() {
      this.changePassword = true;
    },

    async changepassword() {
      let oldpassWord = document.querySelector("#oldpassword").value;
      let newpassword = document.querySelector("#oldtoNew").value;
      let confirmpassword = document.querySelector("#changeconfirm").value;
      if (newpassword == confirmpassword) {
        var responseMail;
        let loginHeader = {
          username: this.userInfo.user.email,
          password: oldpassWord,
        };
        // OldPassword Validations

        await axios
          .post(`${process.env.VUE_APP_API}/login`, loginHeader)
          .then((response) => {
            if (response.data.user) {
              responseMail = response.data.user.email;
            } else {
              responseMail = "error";
            }
          });

        if (responseMail == this.userInfo.user.email) {
          const headerVal = {
            old_password: document.querySelector("#oldpassword").value,
            new_password: document.querySelector("#changeconfirm").value,
          };
          await axios
            .put(
              `${process.env.VUE_APP_API}/api/change-password/?Key=${this.userInfo.token_key}`,
              headerVal,
            )
            .then((response) => {
              if (response.data.message == "Password updated successfully") {
                this.messages = {
                  text: "Password updated successfully",
                  type: "success",
                };
              } else {
                this.messages = {
                  text: " Event Faild",
                  type: "error",
                };
              }
            })
            .catch((error) => {
              console.log(error);
            });
          document.querySelector("#oldpassword").value = "";
          document.querySelector("#oldtoNew").value = "";
          document.querySelector("#changeconfirm").value = "";

          this.changePassword = false;

          setTimeout(() => {
            this.messages = {
              text: " ",
              type: "",
            };
            // this.$router.push({
            //     name: 'Home'
            // })
          }, 3000);
        } else {
          this.errorMessage = {
            text: " Old Password Not Matching",
            type: "error",
          };

          setTimeout(() => {
            this.errorMessage = {
              text: " ",
              type: "",
            };
          }, 1500);
        }
      } else {
        console.log("error");
        this.errorMessage = {
          text: " Confirm Password Miss Match",
          type: "error",
        };
        setTimeout(() => {
          this.errorMessage = {
            text: " ",
            type: "",
          };
        }, 1500);
      }
    },

    async imageHandles() {
      this.profile = false;
      let headerprofile = new FormData();
      headerprofile.append("id", this.userInfo.user.id);
      headerprofile.append(
        "profile",
        document.querySelector("#image_uploads").files[0],
      );

      await axios
        .put(
          `${process.env.VUE_APP_API}/upload_photo/?Key=${this.userInfo.token_key}`,
          headerprofile,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
            this.openProcess();
            this.updateImage(`${response.data.data.profile}`);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .catch((error) => {
          this.messages = {
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        // this.openProcess();
        this.changeProfile = false;
        // window.location.reload();
        // setTimeout(()=>{
        //   this.updateImage(this.profileInfo.data.profile);
        // }, 50)
      }, 3000);
    },

    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
    },

    async onUpload() {
      // upload file
      await axios.post("my-domain.com/file-upload", this.selectedFile);
    },

    async openProcess() {
      axios
        .get(
          `${process.env.VUE_APP_API}/paymentlist/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          console.log(res);
          this.tnxDetails = res.data;
        });
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`,
        )
        .then((response) => (this.profileInfo = response.data));
      console.log("this.profileInfo", this.profileInfo);
    },

    async ProfileEdit() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      this.popUp = true;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_update/${details_id}?Key=${token}&format=json`,
        )
        .then((response) => (this.updateDetails = response.data.data));
      console.log("this.updateDetails", this.updateDetails);
    },

    async SubmitProfile() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      let update = this.updateDetails;
      this.popUp = false;
      console.log("updateDetails123", update);

      await axios
        .put(
          `${process.env.VUE_APP_API}/profile_update/${details_id}/?Key=${token}&format=json`,
          update,
        )
        .then((response) => {
          if (response.data.message == "Profile updated successfully") {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.openProcess();
      }, 3000);
    },
    // access course

    async getCourses(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&Key=${this.userInfo.token_key}&is_published=true&page_size=${this.pageSize}&search=${this.searching}`,
        )
        .then((response) => {
          const res = response.data;

          if (res.status == 400 || !res.data) {
            this.course_count = 0;
            this.course_list = [];
            // this.loading = false;
            return;
          }

          if (res.data.data.status == 200) {
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
            this.course_list = res.data.data.data;
            this.selectedInstructors = this.course_list;
            this.course_count = res.data.total;
            // this.loading = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
/* #image_uploads {
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 4px black;
  width: 350px;
  outline: none;
} */
</style>
